export const MIN_CARD_NUMBER_LENGTH = 16;

export const MAX_CARD_NUMBER_LENGTH = 19;

export const CARD_CVV_LENGTH = 3;

export const CARD_DATE_LENGTH = 5;
